import { Component, EventEmitter, Input, OnInit, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';
import { PageableModel } from '../../models/pageable.model';
import { CrudService } from '../../services/crud.service';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { ZonaModel } from 'src/app/modules/crm/modules/settings/models/zona.model';
import { RoleUtils } from 'src/app/modules/auth/helpers/role.utils';
import { UserModel } from 'src/app/modules/auth/models/user.model';
import { RoleType } from 'src/app/modules/auth/enums/RoleType';

@Component({
  selector: 'app-singlepicker',
  templateUrl: './singlepicker.component.html',
  styleUrls: ['./singlepicker.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SinglepickerComponent implements OnInit {
  @Input() model!: any;

  @Input() name!: string;
  @Input() placeholder!: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() entity = 'zona';
  @Input() myForm!: NgForm;
  @Input() nameField = 'nome';
  @Input() selectField = 'id';
  @Input() select: any;
  @Input() sortField = 'created.desc';
  @Input() emptyChoice = false;
  @Input() emptyModel: any = -1;
  @Input() included = new Array<any>();
  @Input() includeField = '';
  @Input() excluded = new Array<any>();
  @Input() excludedField = '';
  @Input() byPassAdminCheck = true;
  @Output() modelChange = new EventEmitter<any>();
  @Output() modelChangeComplete = new EventEmitter<any>();

  items: any[] = new Array<any>();
  public auth = this.authQuery.auth;

  constructor(private crudService: CrudService<any>, private authQuery: AuthQuery) {
    // this.select = this.select.bind(this);
  }

  ngOnInit(): void {

    this.crudService.getPage(this.entity, 0, 100, this.sortField, {})
      // tslint:disable-next-line: deprecation
      .subscribe(
        (items: PageableModel<any>) => {
          if (this.excluded.length > 0) {
            items.content = items.content.filter(
              (i: any) => this.excluded.indexOf(this.excludedField.split('.').reduce((a: any, b: any) => typeof a === 'object' ? a[b] : a, i)) === -1);
          }
          if (this.included.length > 0) {
            items.content = items.content.filter(
              (i: any) => this.included.indexOf(this.includeField.split('.').reduce((a: any, b: any) => typeof a === 'object' ? a[b] : a, i)) > -1
                || (this.checkRole(this.auth?.user!, RoleType.ADMIN) && this.byPassAdminCheck));
          }
          if (this.model == undefined && this.select) {
            this.model = this.select;
            this.eventChange();
          }
          this.items = items.content;
        },
        error => {

        },
        () => {
        });
  }

  checkRole(user: UserModel, role: RoleType): boolean {
    return RoleUtils.checkRole(user?.roles, role);
  }

  eventChange(): void {
    this.modelChange.emit(this.model);
    this.modelChangeComplete.emit(this.items.find((item) => item.id === this.model) != undefined ?
      this.items.find((item) => item.id === this.model) : this.emptyModel);
  }

}


